import React, { useContext } from 'react';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { MyContext } from '../context';
import Avatar from './avatar';

// This popover is the closest thing this app has to a "My Account" menu
// (there's no separate literal "My Account" entry point anywhere else in
// the nav).
const UserAvatar = () => {
  const { userProfile, clearUserProfile } = useContext(MyContext);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    clearUserProfile();
    window.location.href = '/login';
  };

  // Generate initials for avatar - always return initials, never show icon
  const generateInitials = () => {
    if (!userProfile) return 'U'; // Default to 'U' for User

    if (userProfile.firstName && userProfile.lastName) {
      return `${userProfile.firstName.charAt(0)}${userProfile.lastName.charAt(0)}`.toUpperCase();
    }

    if (userProfile.fullName) {
      return userProfile.fullName
        .split(' ')
        .map(name => name.charAt(0))
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }

    if (userProfile.email) {
      return userProfile.email.charAt(0).toUpperCase();
    }

    return 'U'; // Default fallback
  };

  // Get display name
  const getDisplayName = () => {
    if (!userProfile) return 'User';

    if (userProfile.firstName && userProfile.lastName) {
      return `${userProfile.firstName} ${userProfile.lastName}`;
    }

    if (userProfile.fullName) {
      return userProfile.fullName;
    }

    return userProfile.email || 'User';
  };

  return (
    <Popover className="relative">
      <PopoverButton className="focus:outline-none focus:ring-2 focus:ring-gray-300 rounded-full">
        <Avatar
          size="sm"
          fallback={generateInitials()}
          className="bg-pi-red text-white hover:bg-pi-red/90 transition-colors cursor-pointer"
        />
      </PopoverButton>

      <PopoverPanel className="absolute right-0 z-20 mt-2 w-96 origin-top-right bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
        {/* User Info Section */}
        <div className="p-3 bg-gray-50 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <Avatar
              size="md"
              fallback={generateInitials()}
              className="bg-pi-red text-white"
            />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">
                {getDisplayName()}
              </p>
              <p className="text-xs text-gray-500 truncate">
                {userProfile?.email || 'user@example.com'}
              </p>
            </div>
          </div>
        </div>

        {/* Actions Section */}
        <div className="py-1">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-3 text-left text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-3 transition-colors"
          >
            <span>Sign out</span>
          </button>
        </div>
      </PopoverPanel>
    </Popover>
  );
};

export default UserAvatar;
